<div class="analysts-analysis">
  @if (isZeroDesktop() || isFinnetDesktop()) {
    <app-v3-analysts-desktop-content
      [currentPrice]="currentPrice()"
      [isDetail]="true"
    ></app-v3-analysts-desktop-content>
  } @else if (isFinnet()) {
    <div class="card">
      <div class="header">
        <h3 class="header-label">Analysten</h3>
        @if (updatedAt()) {
          <app-time-ago
            class="updated-at"
            [updatedAt]="updatedAt()"
            format="compact"
          ></app-time-ago>
        }
      </div>
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>

    @if (avgTarget() !== null) {
      <div class="card price-target-card">
        <div class="header">
          <h3 class="header-label">Kursziele</h3>
          @if (analystCountLegend()) {
            <span class="legend">{{ analystCountLegend() }}</span>
          }
        </div>
        <ng-container [ngTemplateOutlet]="priceTargetContent"></ng-container>
      </div>
    }

    @if (hasAnyRatings()) {
      <div class="card rating-tabs-card">
        <h3 class="header-label">Argumente &amp; Thesen</h3>
        <ng-container [ngTemplateOutlet]="ratingTabsContent"></ng-container>
        <div class="rating-list" [appV3TabPanel]="activeRatingTab()">
          @for (r of fullRatings(); track ratingKey(r); let last = $last) {
            <app-v3-analysts-rating-item
              [class.ratings-peek-fade]="last && showRatingsFade()"
              [rating]="r"
              [isDetail]="true"
            ></app-v3-analysts-rating-item>
          }
          @if (showRatingsFade()) {
            <div
              class="ratings-expand"
              role="button"
              tabindex="0"
              (click)="expandRatings()"
              (keyup.enter)="expandRatings()"
              (keydown.space)="$event.preventDefault(); expandRatings()"
            >
              <span class="ratings-expand-label">Alle Einschätzungen</span>
              <span class="ratings-expand-arrow"></span>
            </div>
          }
        </div>
      </div>
    }

    @if (theses().length > 0) {
      <div class="card thesis-card" [appV3TabPanel]="showPositiveTheses()">
        @for (thesis of theses(); track thesis.title) {
          <div class="thesis-item">
            <ng-container
              [ngTemplateOutlet]="thesisContent"
              [ngTemplateOutletContext]="{ $implicit: thesis }"
            ></ng-container>
          </div>
        }
        <span class="thesis-source">Quelle: {{ dataSources.TIPRANKS }}</span>
      </div>
    }
  } @else {
    <div class="card">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>

    @if (avgTarget() !== null) {
      <div class="pt-header">
        <span class="notch"></span>
        <span class="eyebrow-label">Kursziele</span>
        @if (analystCountLegend()) {
          <span class="legend">{{ analystCountLegend() }}</span>
        }
      </div>
      <div class="card price-target-card">
        <ng-container [ngTemplateOutlet]="priceTargetContent"></ng-container>
      </div>
    }

    @if (hasAnyRatings()) {
      <div class="pt-header">
        <span class="notch"></span>
        <span class="eyebrow-label">Argumente &amp; Thesen</span>
      </div>
      <div class="rating-tabs-card">
        <ng-container [ngTemplateOutlet]="ratingTabsContent"></ng-container>
      </div>
      @if (visibleRatings().length > 0) {
        <div class="rating-cards" [appV3TabPanel]="activeRatingTab()">
          @for (r of fullRatings(); track ratingKey(r); let last = $last) {
            @if (last && showRatingsFade()) {
              <div
                class="card ratings-peek-card"
                role="button"
                tabindex="0"
                (click)="expandRatings()"
                (keyup.enter)="expandRatings()"
                (keydown.space)="$event.preventDefault(); expandRatings()"
              >
                <app-v3-analysts-rating-item
                  class="ratings-peek-fade"
                  [rating]="r"
                  [isDetail]="false"
                ></app-v3-analysts-rating-item>
                <span class="ratings-expand-arrow"></span>
              </div>
            } @else {
              <div class="card">
                <app-v3-analysts-rating-item
                  [rating]="r"
                  [isDetail]="true"
                ></app-v3-analysts-rating-item>
              </div>
            }
          }
        </div>
      }
    }

    @if (theses().length > 0) {
      <div class="thesis-list" [appV3TabPanel]="showPositiveTheses()">
        @for (thesis of theses(); track thesis.title) {
          <div class="card thesis-item">
            <ng-container
              [ngTemplateOutlet]="thesisContent"
              [ngTemplateOutletContext]="{ $implicit: thesis }"
            ></ng-container>
          </div>
        }
      </div>
      <span class="thesis-source">Quelle: {{ dataSources.TIPRANKS }}</span>
    }
  }
</div>

<ng-template #content>
  @if (hasContent()) {
    <app-v3-analysts-stats-row
      [gaugeValue]="gaugeValue()"
      [sellGaugeValue]="sellGaugeValue()"
      [isPositive]="isPositive()"
      [rating]="rating()"
      [buyCount]="buyCount()"
      [holdCount]="holdCount()"
      [sellCount]="sellCount()"
      [potential]="potential()"
    ></app-v3-analysts-stats-row>
  }
</ng-template>

<ng-template #priceTargetContent>
  <p class="pt-title">Durchschnittliches Preisziel</p>
  <span
    class="potential-value"
    [class.positive]="targetIsPositive()"
    [class.negative]="!targetIsPositive()"
  >
    @if (avgTargetEuro() !== null) {
      <span class="count" [appCountUp]="avgTargetEuro()!" [decimals]="2"></span> €
    } @else {
      –
    }
  </span>

  @if (consensusHistory() && consensusHistory()!.length > 0) {
    <div class="pt-chart-block">
      <app-price-line-chart
        [highTarget]="highTarget()"
        [avgTarget]="avgTarget()"
        [lowTarget]="lowTarget()"
        [currency]="targetCurrency()"
        [forceCurrency]="isZeroChartData() ? 'EUR' : undefined"
        [consensusHistory]="consensusHistory()"
        [currentPrice]="currentPrice()"
        [height]="150"
        [primaryColor]="chartPrimaryColor()"
        [targetLabelColor]="chartTargetLabelColor()"
        [targetPositiveColor]="chartTargetPositiveColor()"
        [targetNegativeColor]="chartTargetNegativeColor()"
        [uniformGridColor]="true"
        [showAreaFill]="false"
        [animateIn]="true"
        [labelFont]="'Inter'"
      ></app-price-line-chart>
      <span class="pt-source">Quelle: {{ dataSources.TIPRANKS }}</span>
    </div>
  }
</ng-template>

<ng-template #ratingTabsContent>
  <div class="rating-tabs">
    @for (category of availableRatingTabs(); track category) {
      <button
        type="button"
        class="rating-tab"
        [class.active]="activeRatingTab() === category"
        (click)="selectRatingTab(category)"
      >
        <span
          class="rating-tab-icon"
          [class.positive]="category === 'buy'"
          [class.negative]="category === 'sell'"
          [class.hold]="category === 'hold'"
        ></span>
        <span>{{ ratingTabLabel(category) }}</span>
        <span class="rating-tab-separator">·</span>
        <span>{{ ratingTabCount(category) }}</span>
      </button>
    }
  </div>
</ng-template>

<ng-template #thesisContent let-thesis>
  <div class="thesis-title-row">
    <span class="thesis-icon" [class.negative]="!showPositiveTheses()"></span>
    <span class="thesis-title" [class.negative]="!showPositiveTheses()">{{ thesis.title }}</span>
  </div>
  <p class="thesis-body">{{ thesis.text }}</p>
</ng-template>
